export const API_BASE_URL = new URL(window.location).hostname === "localhost" ? 'http://localhost:5000' : process.env.REACT_APP_API_URL;
export const ADMIN_SECRET = process.env.REACT_APP_ADMIN_SECRET